export const validDocumentUploadTypes = ['.csv', '.doc', '.docx', '.pdf', '.png', '.xls', '.xlsx'];

export default {
    validDocumentUploadTypes,
}
